import styled from 'styled-components';

export const ReportDetailsPage = styled.div.attrs({
  className: 'p-6 bg-gray-100 min-h-screen',
})``;

export const ReportTitle = styled.h1.attrs({
  className: 'text-4xl text-center font-semibold text-gray-800 mb-6', 
})``;

export const ReportDate = styled.p.attrs({
  className: 'text-2xl text-center text-gray-600 italic mb-8',
})``;

export const ReportImage = styled.img.attrs({
  className: 'mx-auto mb-6 rounded-lg shadow-lg',
})``;

export const ReportDescription = styled.p.attrs({
  className: 'text-xl text-gray-700 text-center mb-6', 
})``;

export const ReportContent = styled.div.attrs({
  className: 'text-lg text-gray-700 text-center leading-relaxed', 
})``;

export const NavButtons = styled.div.attrs({
  className: 'flex justify-between mt-8',
})``;

export const NavButton = styled.button.attrs({
  className: 'px-5 py-3 text-base font-medium text-white bg-blue-500 rounded hover:bg-blue-600 transition-colors',
})`
  &:disabled {
    background-color: #d1d5db; 
    cursor: not-allowed;
  }
`;
